import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../utils/compose';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormHelperText, TextField, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { subscriptionBaseUrl, httpClient } from '../../http-client/http-client';

const useStyles = makeStyles(theme => ({

}));

const AddCouponDialog = props => {
  const classes = useStyles();
  const { onClose, open, access_token, ...other } = props;
  const { t } = useTranslation();
  const [ error, setError ] = useState(null);
  const [ couponId, setCouponId ] = useState('');

  function handleCancel() {
    onClose(false);
  }

  async function handleOk() {
    if(!couponId || couponId.length === 0) {
      handleCancel();
      return;
    }

    try {
      var url = `${subscriptionBaseUrl}/coupon`;
      var res = await httpClient.post(url, access_token, { Coupon: couponId });
      onClose(true);
    }
    catch(error) {
      console.log(error);
      setError(error.error.HumanError);
    }
  }

  function couponChangeHandler(event) {
    setCouponId(event.target.value);
  }

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="coupon-dialog-title"
      open={open}
      {...other}
    >
      <DialogTitle id="coupon-dialog-title">{t('addCoupon')}</DialogTitle>
      <DialogContent dividers>
        <TextField id="coupon" label={t("coupon")} value={couponId} onChange={couponChangeHandler} />
        <FormHelperText className="Mui-error">{error}</FormHelperText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">{t('cancel')}</Button>
        <Button onClick={handleOk} color="primary">{t('OK')}</Button>
      </DialogActions>
    </Dialog>
  );
};

AddCouponDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  access_token: state.oidc.user.access_token,
});

const mapDispatchToProps = dispatch => ({

});

const composed = compose(
  connect(mapStateToProps, mapDispatchToProps)
)(AddCouponDialog);

export default composed;